module.exports = __webpack_public_path__ + "static/media/absence.33bcd84c.svg";